import React, { useMemo } from 'react';
import './ScheduleList.css';
import { getCategoryColors } from './categoryColorHelper';

export default function ScheduleList({ sections = [], events = [], onEventSelect }) {
  const eventsBySection = useMemo(() => {
    const map = new Map();
    sections.forEach(s => map.set(s.id, []));
    events.forEach(ev => {
      if (!map.has(ev.sectionId)) map.set(ev.sectionId, []);
      map.get(ev.sectionId).push(ev);
    });
    for (const arr of map.values()) arr.sort((a,b)=>a.startTime - b.startTime);
    return map;
  }, [sections, events]);

  const fmt = (d) => d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

  return (
    <div className="schedule-list">
      {sections.map(sec => {
        const evts = eventsBySection.get(sec.id) || [];
        if (evts.length === 0) return null;
        return (
          <div key={sec.id} className="sl-section">
            <div className="sl-section-header">{sec.name}</div>
            <div className="sl-events">
              {evts.map(ev => {
                const colors = getCategoryColors(ev.category);
                return (
                  <div key={ev.id} className="sl-event" onClick={() => onEventSelect && onEventSelect(ev)}>
                    <div className="sl-color-bar" style={{ background: ev.borderColor || colors.border }} />
                    <div className="sl-event-time">{fmt(ev.startTime)} – {fmt(ev.endTime)}</div>
                    <div className="sl-event-title">{ev.title}</div>
                    <div className="sl-event-meta">
                      {(() => {
                        const hasCat = !!ev.categoryLabel;
                        const hasType = !!ev.eventTypeLabel;
                        if (hasCat && hasType) {
                          return (
                            <span
                              className="sl-badge"
                              style={{
                                background: ev.color || colors.bg,
                                color: ev.foregroundColor || colors.fg,
                                borderColor: ev.borderColor || colors.border,
                              }}
                            >
                              {ev.categoryLabel} - {ev.eventTypeLabel}
                            </span>
                          );
                        }
                        if (hasCat) {
                          return (
                            <span
                              className="sl-badge"
                              style={{
                                background: ev.color || colors.bg,
                                color: ev.foregroundColor || colors.fg,
                                borderColor: ev.borderColor || colors.border,
                              }}
                            >
                              {ev.categoryLabel}
                            </span>
                          );
                        }
                        if (hasType) {
                          return <span className="sl-badge">{ev.eventTypeLabel}</span>;
                        }
                        return null;
                      })()}
                      {ev.speaker && <span>👤 {ev.speaker}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
